import React from 'react'
import {Input, Button, Tag} from 'antd'
import { CloudDownloadOutlined } from '@ant-design/icons'
import { connect } from 'react-redux'
import { PERMISSIONS, createPermitFunction } from '../../../Evolve/Utilities/permissions'
import { isAdmin } from 'Common'

const styles = {
  wrapper: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: 25,
  },
  heading: {
    flex: 1,
    margin: 0,
  },
}

type Props = {
  searchTerm: string,
  userPermissions: [],
  onChangeSearch: () => void,
  onSubmitSearch: () => void,
  onClickExport: () => void,
  onClickNewUser: () => void,
}

class Header extends React.PureComponent<Props> {

  render() {

    const {
      searchTerm,
      userPermissions,
      onChangeSearch,
      onSubmitSearch,
      onClickExport,
      onClickNewUser,
    } = this.props


    return (

      <div style={styles.wrapper}>

        <h1 style={styles.heading}>
          Users
        </h1>

        <Input.Search
          value={searchTerm}
          onChange={event => onChangeSearch(event.target.value)}
          onSearch={onSubmitSearch}
          placeholder='Search'
          enterButton
          style={{ width: 250 }}
        />

        <div style={{ width: 10 }} />

        {(isAdmin() && createPermitFunction(userPermissions)('exports')) && (
          <React.Fragment>
            <Button onClick={onClickExport}>
              <CloudDownloadOutlined style={{ fontSize: 16, marginTop: 3 }} />
            </Button>
            <div style={{ width: 10 }} />
          </React.Fragment>
        )}

        <Button type='primary' onClick={onClickNewUser}>
          New User
        </Button>

      </div>


    )

  }

}

const mapStateToProps = (state) => ({
  userPermissions: (state.user && state.user.permissions) || [],
})

export default connect(mapStateToProps)(Header)
